<div class="main-container" [ngClass]="{'expanded-sidebar': isToggled || isHovered}">
  <mat-toolbar class="app-toolbar">

    <div class="app-home">
      <div class="app-home-menu-button">
        <button mat-mini-fab color="primary" (click)="isToggled = !isToggled">
          <fa-icon [icon]="faMenu" size="lg"></fa-icon>
        </button>
      </div>
      <div class="app-home-title app-logo" routerLink="/home">
        <img src="assets/epax_logo.png" />
      </div>
    </div>

    <span class="toolbar-gap">
      <div class="client-logo">
        <img [src]="getLogo()" />
      </div>
    </span>

    <app-action-buttons></app-action-buttons>

    <div class="toolbar-actions">
      <button mat-mini-fab aria-label="icon-button-refresh" color="primary" *ngIf="hasLoadDataMethod()"
        (click)="onRefreshData()" matTooltip="{{'common.refresh' | translate}}">
        <fa-icon [icon]="faRefresh" size="lg"></fa-icon>
      </button>

      <button mat-mini-fab class="extended" [matMenuTriggerFor]="userMenu" aria-label="icon-button with a user menu"
        color="primary">
        {{authService.authenticatedUser?.userName}}
        <fa-icon [icon]="faUser" size="lg"></fa-icon>
      </button>
      <mat-menu #userMenu="matMenu" class="toolbar-actions-menu" xPosition="before">
        <button mat-menu-item (click)="openGdprDialog()">
          <fa-icon [icon]="faGdpr" size="lg"></fa-icon>
          <span>{{'main.user-menu.gdpr' | translate}}</span>
        </button>
        <button mat-menu-item (click)="openLegalNoticeDialog()">
          <fa-icon [icon]="faLegalNotice" size="lg"></fa-icon>
          <span>{{'main.user-menu.legal-notice' | translate}}</span>
        </button>
      </mat-menu>

      <button mat-mini-fab aria-label="icon-button with a help" color="primary" (click)="openHelpDialog()"
        matTooltip="{{'common.help' | translate}}">
        <fa-icon [icon]="faHelp" size="lg"></fa-icon>
      </button>
      <app-language></app-language>
    </div>
  </mat-toolbar>

  <mat-sidenav-container #sideNav class="sidenav-container" [hasBackdrop]="false">
    <mat-sidenav class="sidenav-menu" mode="side" (mouseenter)="onMouseEnter($event)"
      (mouseleave)="onMouseLeave($event)" opened>
      <mat-nav-list class="main-list">

        <mat-list-item class="list-item-parent" [disabled]="true" *ngIf="authService.hasPermission(permissionEnum.Documents)">
          <span class="list-item-icon"><fa-icon [icon]="faDocuments" size="lg"></fa-icon></span>
          <span class="list-item-label" *ngIf="isToggled || isHovered">{{'menu.documents' | translate |
            uppercase}}</span>
        </mat-list-item>
        <mat-nav-list *ngIf="authService.hasPermission(permissionEnum.Documents)">
          <mat-list-item routerLink="/documents/receipts" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}" [disableRipple]="true" *ngIf="authService.hasPermission(permissionEnum.Receipts)">
            <span class="list-item-icon"><fa-icon [icon]="faReceipts" size="lg"></fa-icon></span>
            <span class="list-item-label" *ngIf="isToggled || isHovered">{{'menu.documents.receipts' | translate |
              uppercase}}</span>
          </mat-list-item>
          <mat-list-item routerLink="/documents/daily-reports" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}" [disableRipple]="true" *ngIf="authService.hasPermission(permissionEnum.DailyReports)">
            <span class="list-item-icon"><fa-icon [icon]="faDailyReports" size="lg"></fa-icon></span>
            <span class="list-item-label" *ngIf="isToggled || isHovered">{{'menu.documents.daily-reports' | translate |
              uppercase}}</span>
          </mat-list-item>
          <mat-list-item routerLink="/documents/non-fiscals" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}" [disableRipple]="true" *ngIf="authService.hasPermission(permissionEnum.NonFiscals)">
            <span class="list-item-icon"><fa-icon [icon]="faNonFiscalsDocuments" size="lg"></fa-icon></span>
            <span class="list-item-label" *ngIf="isToggled || isHovered">{{'menu.documents.non-fiscals' | translate |
              uppercase}}</span>
          </mat-list-item>
        </mat-nav-list>

        <mat-list-item class="list-item-parent" [disabled]="true" *ngIf="authService.hasPermission(permissionEnum.Reports)">
          <span class="list-item-icon"><fa-icon [icon]="faReports" size="lg"></fa-icon></span>
          <span class="list-item-label" *ngIf="isToggled || isHovered">{{'menu.reports' | translate | uppercase}}</span>
        </mat-list-item>
        <mat-nav-list *ngIf="authService.hasPermission(permissionEnum.Reports)">
          <mat-list-item routerLink="/reports/sales-statement" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}" [disableRipple]="true" *ngIf="authService.hasPermission(permissionEnum.SalesStatement)">
            <span class="list-item-icon"><fa-icon [icon]="faSales" size="lg"></fa-icon></span>
            <span class="list-item-label" *ngIf="isToggled || isHovered">{{'menu.reports.sales-statement' | translate |
              uppercase}}</span>
          </mat-list-item>
          <mat-list-item routerLink="/reports/printers-status" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}" [disableRipple]="true" *ngIf="authService.hasPermission(permissionEnum.PrinterStatus)">
            <span class="list-item-icon"><fa-icon [icon]="faPrinterStatus" size="lg"></fa-icon></span>
            <span class="list-item-label" *ngIf="isToggled || isHovered">{{'menu.reports.printer-status' | translate |
              uppercase}}</span>
          </mat-list-item>
          <!-- <mat-list-item routerLink="/reports/queue-status" routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: true}" click="onMenuItemClick($event)" *ngIf="authService.hasPermission(permissionEnum.Documents)">
              <fa-icon [icon]="faQueueStatus" size="lg"></fa-icon>
              <span *ngIf="isToggled || isHovered">{{'menu.reports.queue-status' | translate | uppercase}}</span>
            </mat-list-item> -->
        </mat-nav-list>

        <mat-list-item class="list-item-parent" [disabled]="true" *ngIf="authService.hasPermission(permissionEnum.Administration)">
          <span class="list-item-icon"><fa-icon [icon]="faAdministration" size="lg"></fa-icon></span>
          <span class="list-item-label" *ngIf="isToggled || isHovered">{{'menu.administration' | translate |
            uppercase}}</span>
        </mat-list-item>
        <mat-nav-list *ngIf="authService.hasPermission(permissionEnum.Administration)">
          <mat-list-item routerLink="/administration/printers" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}" [disableRipple]="true" *ngIf="authService.hasPermission(permissionEnum.Printers)">
            <span class="list-item-icon"><fa-icon [icon]="faPrinters" size="lg"></fa-icon></span>
            <span class="list-item-label" *ngIf="isToggled || isHovered">{{'menu.administration.printers' | translate |
              uppercase}}</span>
          </mat-list-item>

          <mat-list-item routerLink="/administration/shops" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: true}" [disableRipple]="true" *ngIf="authService.hasPermission(permissionEnum.Shops)">
            <span class="list-item-icon"><fa-icon [icon]="faShops" size="lg"></fa-icon></span>
            <span class="list-item-label" *ngIf="isToggled || isHovered">{{'menu.administration.shops' | translate |
              uppercase}}</span>
          </mat-list-item>
          <!-- <mat-list-item *ngIf="isUserAdmin()" routerLink="/administration/users"
              routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" click="onMenuItemClick($event)">
              <fa-icon [icon]="faUsers" size="lg"></fa-icon>
              <span *ngIf="isToggled || isHovered">{{'menu.administration.users' | translate | uppercase}}</span>
            </mat-list-item> -->
        </mat-nav-list>
          <!--<mat-list-item class="list-item-parent" routerLink="/report-issue" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}" [disableRipple]="true">
          <span class="list-item-icon"><fa-icon [icon]="faReportIssue" size="lg"></fa-icon></span>
          <span class="list-item-label" *ngIf="isToggled || isHovered">{{'menu.report-issue' | translate |
            uppercase}}</span>
        </mat-list-item> -->
      </mat-nav-list>

      <div class="sidenav-footer">
        <div class="logo">
          <img [src]="appService.rootRelative('/assets/vimana_logo.png')" />
        </div>
        <div class="info" *ngIf="isToggled || isHovered">
          <span>Copyright &copy; {{currentYear}}</span>
          <span>{{'common.version' | translate}}: {{version}}</span>
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content [ngClass]="{'on-hover': isHovered && !isToggled}">
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>